import React, { Component } from "react";
import styles from "./TextEmojiArea.module.scss";
import Emoji from "../../1_atoms/Emoji/Emoji";
import { cx } from "../../../helpers/ClassNames.helper";
import { t } from "../../../helpers/translate.helper";


const emojis = [
	{ emoji: '1f62e', emotion: 'EMOT_SURPRISED', duration: 1000 },
	{ emoji: '1f600', emotion: 'EMOT_SMILE', duration: 1000 },
	{ emoji: '1f624', emotion: 'EMOT_ANGRY', duration: 1000 },
	{ emoji: '1f622', emotion: 'EMOT_SAD', duration: 1000 },
	{ emoji: '1f611', emotion: 'EMOT_BORED', duration: 1000 },
	{ emoji: '1f618', emotion: 'MIMIC_KISS', duration: 1500 },
	{ emoji: '1f606', emotion: 'EMOT_HAPPY', duration: 1000 },
	{ emoji: '1f609', emotion: 'MIMIC_WINK_L', duration: 1250 },
	{ emoji: '1f635', emotion: 'EMOT_CRAZY', duration: 1000 },
];

class TextEmojiArea extends Component {
	constructor(props) {
		super(props);

		this.value = [];
	}

	static defaultProps = {
		maxLength: 140,
	};

	onKeyDown(event) {
		// prevent input if text-field full, except backspace, delete and arrows
		if (((event.key.length === 1 && !event.ctrlKey) || event.key === 'Enter')) {
			const length = this.paragraphRef.innerHTML.replace(/<.*?>/gi, '').length;
			if (length >= this.props.maxLength) {
				event.preventDefault();
			}
		}
	}

	onInput(event) {
		let selection = document.getSelection();
		const newInner = this.paragraphRef.innerHTML.replace(/(?!<img|<br)<[^>]*?>/gi, '');
		if (newInner !== this.paragraphRef.innerHTML) {
			this.paragraphRef.innerHTML = newInner;
			if (selection && selection.focusNode === this.paragraphRef && this.paragraphRef.lastChild) {
				var range = document.createRange();
				range.setStart(this.paragraphRef.lastChild, this.paragraphRef.lastChild.nodeValue.length);
				range.collapse(true);
				selection.removeAllRanges();
				selection.addRange(range);
			}

			if (newInner.length > 0) {
				this.paragraphRef.className = styles.text;
			} else {
				this.paragraphRef.className = cx(styles.text, styles.empty);
			}
		}
	}

	addEmoji(emojiObj, event) {
		if(this.props.onAddEmoji) this.props.onAddEmoji(emojiObj, event);

		event.preventDefault();

		const element = document.createElement('img');
		element.src = `./emojis/${emojiObj.emoji}.png`;
		element.setAttribute('data-id', emojiObj.emoji);

		this.insertAtCursor(this.paragraphRef, element);

		return false;
	}

	insertAtCursor(ref, element) {
		const selection = document.getSelection();
		if (selection && (selection.focusNode === this.paragraphRef || selection.focusNode.parentElement === this.paragraphRef)) {
			const range = selection.getRangeAt(0);
			if (range) {
				range.deleteContents();
				range.insertNode(element);
				range.collapse(false);
			}
		}
		else if (this.paragraphRef) {
			this.paragraphRef.appendChild(element);
		}
	}

	enforceLength() {
		const childNodes = this.paragraphRef.childNodes;

		let length = 0;

		for (let i = 0; i < childNodes.length; i++) {
			if (length < this.props.maxLength) {
				length += childNodes[i].nodeName === '#text' ? childNodes[i].nodeValue.length : 1;
				if (length > this.props.maxLength) {
					// only accessable when nodeType === '#text'
					const overflow = length - this.props.maxLength;
					this.paragraphRef.replaceChild(
						document.createTextNode(childNodes[i].nodeValue.slice(0, - overflow)),
						childNodes[i]
					);
				}
			}
			else {
				// already full, remove excess
				this.paragraphRef.removeChild(childNodes[i]);
			}
		}

		if (this.paragraphRef.innerText.length > 0) {
			this.paragraphRef.className = styles.text;
		} else {
			this.paragraphRef.className = cx(styles.text, styles.empty);
		}
	}

	handleSend() {
		const message = [];

		for (let child of this.paragraphRef.childNodes) {
			if (child.nodeName === '#text') {
				message.push(child.nodeValue);
			} else if (child.nodeName === 'IMG') {
				message.push(emojis.find((e) => e.emoji === child.getAttribute('data-id')));
			}
		}

		this.props.handleSend(message);
	}

	render() {
		const { label, icon, maxLength } = this.props;

		return (
			<div className={styles.host}>
				{label && <label>{icon && <i className={"fas fa-" + icon}></i>}{label}</label>}
				<div className={styles.textWrapper}>
					<pre
						ref={ref => { this.paragraphRef = ref; }}
						className={cx(styles.text, styles.empty)}
						contenteditable="true"
						onKeyDown={this.onKeyDown.bind(this)}
						onInput={this.onInput.bind(this)}
						onBlur={this.enforceLength.bind(this)}>
					</pre>
					<div className={styles.placeholder}>{t('text.placeholder', {maxLength})}</div>
					<div className={styles.buttonBar}>
						<div className={cx(styles.emojis, '__scrollbar_dark')}>
							{
								emojis.map(emoji =>
									<div
										key={emoji.emoji}
										className={styles.emoji}
										onMouseDown={(event) => this.addEmoji(emoji, event)}>
										<Emoji code={emoji.emoji} size="24" />
									</div>
								)
							}
						</div>
						<div
							className={styles.button}
							onClick={this.handleSend.bind(this)} />
					</div>
				</div>
			</div >
		)
	};
}

export default TextEmojiArea;
